module.exports = __webpack_public_path__ + "static/img/ss3-2.3200ea8c.png";